import React from 'react'

const ManuallyAddSubscription = () => {
  return (
    <div>
      under construction
    </div>
  )
}

export default ManuallyAddSubscription
